import styled from 'styled-components';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import _ from 'lodash';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { ReturnExchangesApi } from '../../../../../../../apis/ReturnExchangesApi';
import { useFetcher } from '../../../../fetcher/useFetcher';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';
import { useEffect, useState } from 'react';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import { customToast } from '../../../../../../../components/toast/custom-react-toastify/v1';
import { CustomDateUtils } from '../../../../../../../utils/CustomDateUtils';
import { ProductOptionsApi } from '../../../../../../../apis/ProductOptionsApi';
import { GlobalWegetProductOptionModal } from '../../../../../../../global-wegets/global-weget-product-option-modal';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .view-button{
    background-color: var(--blueColor1);
    color: #fff;
    border-radius: 3px;
    border:none;
    height: 30px;
    padding: 0 10px;
    font-weight: 600;
    cursor: pointer;
  }
`

const StyledModalHeader = styled.div`
    padding: 10px;
`;

const StyledModalBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    input{
        border: 1px solid #dee2e6;
    }

    .optionCodeButton{
        background-color: #333;
        color: #fff;
        border-radius: 3px;
        border:none;
        padding: 0 10px;
        font-weight: 600;
        cursor: pointer;
    }

    .product-info-box{
        border: 1px solid #dee2e6;
        padding:10px;
        border-radius: 5px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        gap: 20px;

        .label{
            font-weight: 600;
            color:#333;
        }

        .content{
            padding-left: 5px;
            margin-top:5px;
        }
    }
`;

const StyledModalFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        background-color: var(--blueColor1);
        color: #fff;
        font-weight: 600;
        border:none;
    }
`;

export function TdOriginOrderInfo({
    returnExchange
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const [editModalOpen, setEditModalOpen] = useState(false);

    const handleReqChange = async (editableData) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().updateList({
            headers: headers,
            body: {
                returnExchanges: [editableData]
            }
        });

        if (response?.content) {
            await fetcher.fetchReturnExchanges();
        }
        setEditModalOpen(false);
        CustomBackdropController().hideBackdrop();
    }
    return (
        <>
            <StyledTableCell>
                <CustomBlockButton
                    type='button'
                    className='view-button'
                    onClick={(e) => { e.stopPropagation(); setEditModalOpen(true) }}
                >보기</CustomBlockButton>
            </StyledTableCell>

            {editModalOpen &&
                <EditModal
                    open={editModalOpen}
                    onClose={() => setEditModalOpen(false)}
                    returnExchange={returnExchange}
                    onReqChange={handleReqChange}
                />
            }
        </>
    );
}

function EditModal({
    open,
    onClose,
    returnExchange,
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [editableReturnExchange, setEditableReturnExchange] = useState(_.cloneDeep(returnExchange));
    const [productInfo, setProductInfo] = useState({
        productName: '',
        optionName: '',
    });
    const [productOptionSelectModalOpen, setProductOptionSelectModalOpen] = useState(false);

    useEffect(() => {
        if (!editableReturnExchange?.exchangeReleaseOptionCode) {
            return;
        }

        handleReqFetchProductOptions();
    }, [editableReturnExchange?.exchangeReleaseOptionCode])

    const handleReqFetchProductOptions = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const response = await ProductOptionsApi().searchListByOptionCodes({
            headers: headers,
            body: {
                optionCodes: [editableReturnExchange?.exchangeReleaseOptionCode]
            }
        });

        if (response?.content && response?.content.length > 0) {
            setProductInfo({
                productName: response?.content[0]?.product?.name,
                optionName: response?.content[0]?.name
            });
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
                maxWidth='md'
            >
                <StyledModalHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            원 주문정보
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledModalHeader>
                <StyledModalBody>
                    <div className='product-info-box'>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>채널주문일시</div>
                                <div className='content'>{CustomDateUtils().dateToYYYYMMDDhhmmss(editableReturnExchange?.channelOrderDate)}</div>
                            </div>
                            <div>
                                <div className='label'>주문수집일시</div>
                                <div className='content'>{CustomDateUtils().dateToYYYYMMDDhhmmss(editableReturnExchange?.erpItemCreatedAt)}</div>
                            </div>
                            <div>
                                <div className='label'>출고일시</div>
                                <div className='content'>{CustomDateUtils().dateToYYYYMMDDhhmmss(editableReturnExchange?.releaseAt)}</div>
                            </div>
                            <div>
                                <div className='label'>교환반품 등록일시</div>
                                <div className='content'>{CustomDateUtils().dateToYYYYMMDDhhmmss(editableReturnExchange?.createdAt)}</div>
                            </div>
                        </div>
                    </div>
                    <div className='product-info-box'>
                        <div>
                            <div className='label'>출고상품 옵션코드</div>
                            <div className='content'>{editableReturnExchange?.releaseOptionCode}</div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>출고상품명</div>
                                <div className='content'>{productInfo?.productName}</div>
                            </div>
                            <div>
                                <div className='label'>출고옵션명</div>
                                <div className='content'>{productInfo?.optionName}</div>
                            </div>
                            <div>
                                <div className='label'>수량</div>
                                <div className='content'>{editableReturnExchange?.unit}</div>
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>판매채널</div>
                                <div className='content'>{editableReturnExchange?.salesChannel || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>주문번호1</div>
                                <div className='content'>{editableReturnExchange?.orderNumber1 || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>주문번호2</div>
                                <div className='content'>{editableReturnExchange?.orderNumber2 || '-'}</div>
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>채널상품코드</div>
                                <div className='content'>{editableReturnExchange?.channelProdCode || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>채널옵션코드</div>
                                <div className='content'>{editableReturnExchange?.channelOptionCode || '-'}</div>
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>판매가격</div>
                                <div className='content'>{editableReturnExchange?.price ?? '-'}</div>
                            </div>
                            <div>
                                <div className='label'>배송비</div>
                                <div className='content'>{editableReturnExchange?.deliveryCharge ?? '-'}</div>
                            </div>
                        </div>
                        <div>
                            <div className='label'>바코드</div>
                            <div className='content'>{editableReturnExchange?.barcode || '-'}</div>
                        </div>
                    </div>
                    <div className='product-info-box'>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>수취인명</div>
                                <div className='content'>{editableReturnExchange?.receiver}</div>
                            </div>
                            <div>
                                <div className='label'>수취인연락처1</div>
                                <div className='content'>{editableReturnExchange?.receiverContact1}</div>
                            </div>
                            <div>
                                <div className='label'>수취인연락처2</div>
                                <div className='content'>{editableReturnExchange?.receiverContact2 || '-'}</div>
                            </div>
                        </div>
                        <div>
                            <div className='label'>주소</div>
                            <div className='content'>{editableReturnExchange?.destination}</div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>주소상세</div>
                                <div className='content'>{editableReturnExchange?.destinationDetail || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>우편번호</div>
                                <div className='content'>{editableReturnExchange?.zipCode || '-'}</div>
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>택배사</div>
                                <div className='content'>{editableReturnExchange?.courier || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>배송방식</div>
                                <div className='content'>{editableReturnExchange?.transportType || '-'}</div>
                            </div>
                        </div>
                        <div>
                            <div className='label'>배송메세지</div>
                            <div className='content'>{editableReturnExchange?.deliveryMessage || '-'}</div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>운송장번호</div>
                                <div className='content'>{editableReturnExchange?.waybillNumber || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>기타운송장번호</div>
                                <div className='content'>{editableReturnExchange?.extraWaybillNumbers || '-'}</div>
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>운송코드</div>
                                <div className='content'>{editableReturnExchange?.freightCode || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>출고지</div>
                                <div className='content'>{editableReturnExchange?.releaseLocation || '-'}</div>
                            </div>
                        </div>
                    </div>
                    <div className='product-info-box'>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>메모1</div>
                                <div className='content'>{editableReturnExchange?.managementMemo1 || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>메모2</div>
                                <div className='content'>{editableReturnExchange?.managementMemo2 || '-'}</div>
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>메모3</div>
                                <div className='content'>{editableReturnExchange?.managementMemo3 || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>메모4</div>
                                <div className='content'>{editableReturnExchange?.managementMemo4 || '-'}</div>
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>메모5</div>
                                <div className='content'>{editableReturnExchange?.managementMemo5 || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>메모6</div>
                                <div className='content'>{editableReturnExchange?.managementMemo6 || '-'}</div>
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>메모7</div>
                                <div className='content'>{editableReturnExchange?.managementMemo7 || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>메모8</div>
                                <div className='content'>{editableReturnExchange?.managementMemo8 || '-'}</div>
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px' }}>
                            <div>
                                <div className='label'>메모9</div>
                                <div className='content'>{editableReturnExchange?.managementMemo9 || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>메모10</div>
                                <div className='content'>{editableReturnExchange?.managementMemo10 || '-'}</div>
                            </div>
                        </div>
                    </div>
                </StyledModalBody>
            </CustomDialog>
        </>
    );
}